import React from "react";
import { Tooltip } from "@mui/material";

import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";

import { LastUpdatedDetails } from "views/pages/manage/employeeManagement/userProfile/helper";

const LogsPanel = ({ logs }) => {
  const auditColumns = [
    new AGridColDef("event", "Event")
      .setMinWidth(200)
      .renderCellComponent((params) =>
        params?.value ? <span>{params.value}</span> : <div>-</div>,
      ),
    ,
    new AGridColDef("updatedOn", "Updated On")
      .setMinWidth(200)
      .renderCellComponent((params) => {
        const date = params?.row?.updatedOn || params?.row?.createdOn;
        const by = params?.row?.updatedBy || params?.row?.createdBy;
        const displayText = date ? LastUpdatedDetails(date, by) : "-";
        return (
          <Tooltip title={displayText}>
            <span>{displayText}</span>
          </Tooltip>
        );
      }),
    new AGridColDef("oldValue", "Old Value")
      .setMinWidth(150)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params.value}>{params.value}</Tooltip>
        ) : (
          <div>-</div>
        ),
      ),
    ,
    new AGridColDef("newValue", "New Value")
      .setMinWidth(150)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params.value}>{params.value}</Tooltip>
        ) : (
          <div>-</div>
        ),
      ),
    ,
  ];
  return (
    <ADataGrid
      rows={logs}
      columns={auditColumns || []}
      rowId={(row) => row.id}
      height="300px"
      pagination={false}
      rowCount={logs?.length || 0}
    />
  );
};

export default LogsPanel;
